import React from 'react';

import AdoptedRegion from '../primitives/AdoptedRegion';

interface IContentHeaderProps {
    content: DocumentFragment | null;
}

const ContentHeader: React.FC<IContentHeaderProps> = ({ content }) => (
    <AdoptedRegion as="header" className="content-page__header" content={content} />
);

export default ContentHeader;
